import React, { useEffect, useState, useRef } from 'react';

import { Link } from 'react-scroll';

function throttle(callback, waitTime) {
  let timerId = null;
  return (e) => {
    if (timerId) return;
    timerId = setTimeout(() => {
      callback.call(this, e);
      timerId = null;
    }, waitTime);
  };
}

function Navigation({ isStarted, setIsStarted }) {
  const [slidingMenu, setSlidingMenu] = useState(false);

  useEffect(() => {
    if (slidingMenu) {
      document.body.classList.add('menu-open');
    } else {
      document.body.classList.remove('menu-open');
    }
  }, [slidingMenu]);

   // 슬라이딩 메뉴 출현 시 본문 스크롤을 금지
   useEffect(() => {
    if (slidingMenu) {
      document.body.style.cssText = `position: fixed; top: -${window.scrollY}px`;
      return () => {
        const scrollY = document.body.style.top;
        document.body.style.cssText = `posotion: ""; top: "";`;
        window.scrollTo(0, parseInt(scrollY || '0') * -1);
      };
    }
  }, [slidingMenu]);

  const [hide, setHide] = useState(false);
  const [pageY, setPageY] = useState(0);
  const documentRef = useRef(document);

  const handleScroll = () => {
    const { pageYOffset } = window;
    const deltaY = pageYOffset - pageY;
    const hide = pageYOffset !== 0 && deltaY >= 0;
    setHide(hide);
    setPageY(pageYOffset);
    setIsStarted(pageYOffset === 0 ? window.outerWidth > 640 ? true : false : false);
  };

  const throttleScroll = throttle(handleScroll, 50);

  useEffect(() => {
    documentRef.current.addEventListener('scroll', throttleScroll);
    return () => {
      if (!window.onscroll) {
        setTimeout(() => {
          setHide(false);
        }, 1400);
      };
      documentRef.current.removeEventListener('scroll', throttleScroll);
    };
  }, [pageY]);

  return (
    <>
      <nav className={hide ? 'hide' : ''} id="nav-menu-bar" style={{ backgroundColor: isStarted ? 'transparent' : '#ffffff' }}>
        <ul className="menu">
          <li>
            <Link
              to="about-container"
              activeClass="on"
              spy={true}
              smooth={true}
              duration={250}
              delay={80}
              offset={-120}
            >
              소개
            </Link>
          </li>
          <li>
            <Link
              to="services-container"
              activeClass="on"
              spy={true}
              smooth={true}
              duration={250}
              delay={80}
            >
              시설이용
            </Link>
          </li>
          <li>
            <Link
              to="hash-reservation"
              activeClass="on"
              spy={true}
              smooth={true}
              duration={250}
              delay={80}
              offset={-130}
            >
              시설예약
            </Link>
          </li>
          <li>
            <Link
              to="hash-contact"
              activeClass="on"
              spy={true}
              smooth={true}
              duration={250}
              delay={80}
            >
              이용문의
            </Link>
          </li>
        </ul>
        <ul className="sns">
          <li>
            <a href="https://www.instagram.com/si0gan/" target="_blank">
              Instagram
            </a>
          </li>
          <li>
            <a href="https://blog.naver.com/si0gan" target="_blank">
              Blog
            </a>
          </li>
        </ul>
      </nav>
      <div className={`menu-icon ${hide ? ' hide' : ''}`} onClick={() => setSlidingMenu(!slidingMenu)}>
        <span className="menu-icon__line menu-icon__line-left" />
        <span className="menu-icon__line" />
        <span className="menu-icon__line menu-icon__line-right" />
      </div>
      <div className="menu-container">
        <div className="menu-sliders" />
        <div className="menu-sliders" />
        <div className="menu-sliders" />
        <div className="sliding-menu">
          <ul>
            <li>
              <Link
                to="about-container"
                spy={true}
                smooth={true}
                duration={250}
                delay={80}
                offset={-110}
                onClick={() => setSlidingMenu(false)}
              >
                소개
              </Link>
            </li>
            <li>
              <Link
                to="services-container"
                spy={true}
                smooth={true}
                duration={250}
                delay={80}
                offset={-115}
                onClick={() => setSlidingMenu(false)}
              >
                시설이용
              </Link>
            </li>
            <li>
              <Link
                to="hash-reservation"
                spy={true}
                smooth={true}
                duration={250}
                delay={80}
                offset={-110}
                onClick={() => setSlidingMenu(false)}
              >
                시설예약
              </Link>
            </li>
            <li>
              <Link
                to="hash-contact"
                spy={true}
                smooth={true}
                duration={250}
                delay={80}
                offset={-110}
                onClick={() => setSlidingMenu(false)}
              >
                이용문의
              </Link>
            </li>
            <li className="sns-list">
              <a href="https://www.instagram.com/si0gan/" target="_blank">
                Instagram
              </a>
              <a href="https://blog.naver.com/si0gan" target="_blank">
                Blog
              </a>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
}

export default Navigation;
